<section class="section-div">
  <div class="header-div">
    <h4>
      <ion-icon name="layers-outline"></ion-icon> Physical Infrastructure -
      {{ incubaterName }}
    </h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Dedicated area for Incubation Center
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.dedicatedAreaStatus)"
                    [style.background]="pickColor(getValue.dedicatedAreaStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.dedicatedAreaStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Dedicated area for Incubation Center</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.dedicatedAreaIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.dedicatedAreaIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Area allotted for Incubation Centre (in Sq. ft) :
                            <b>{{ getValue.dedicatedAreaSqftArea }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.dedicatedAreaDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.dedicatedAreaStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.dedicatedAreaReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>

                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.dedicatedAreaStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('dedicatedAreaStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('dedicatedAreaStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.dedicatedAreaStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('dedicatedAreaStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Office space and Co-working space with Computer, Air
                    Conditioner and other mandatory equipments
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.officeAndCoWorkingSpaceStatus)
                    "
                    [style.background]="
                      pickColor(getValue.officeAndCoWorkingSpaceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.officeAndCoWorkingSpaceStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Office space and Co-working space with Computer, Air
                    Conditioner and other mandatory equipments
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.officeAndCoWorkingSpaceIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.officeAndCoWorkingSpaceIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.officeAndCoWorkingSpaceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.officeAndCoWorkingSpaceStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.officeAndCoWorkingSpaceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.officeAndCoWorkingSpaceStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('officeAndCoWorkingSpaceStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('officeAndCoWorkingSpaceStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.officeAndCoWorkingSpaceStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('officeAndCoWorkingSpaceStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Maker space / Prototype development centre / Analytical labs
                    / Machineries / Fields established as per the thrust areas
                    supported
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.makerSpacePrototypeStatus)
                    "
                    [style.background]="
                      pickColor(getValue.makerSpacePrototypeStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.makerSpacePrototypeStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Maker space / Prototype development centre / Analytical labs
                    / Machineries / Fields established as per the thrust areas
                    supported
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.makerSpacePrototypeIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.makerSpacePrototypeIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.makerSpacePrototypeUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.makerSpacePrototypeUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of support infrastructure established :
                            <b>{{
                              getValue.makerSpacePrototypeUtilitySpace
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.makerSpacePrototypeDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.makerSpacePrototypeStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.makerSpacePrototypeReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.makerSpacePrototypeStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('makerSpacePrototypeStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('makerSpacePrototypeStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.makerSpacePrototypeStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('makerSpacePrototypeStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Specialized software, tools and inventories for designing
                    and IoT based projects
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.specializedSoftwareStatus)
                    "
                    [style.background]="
                      pickColor(getValue.specializedSoftwareStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.specializedSoftwareStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <!-- No. of such facilities created  -->
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Specialized software, tools and inventories for designing
                    and IoT based projects
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.specializedSoftwareIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.specializedSoftwareIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.specializedSoftwareDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.specializedSoftwareStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.specializedSoftwareReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.specializedSoftwareStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('specializedSoftwareStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('specializedSoftwareStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.specializedSoftwareStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('specializedSoftwareStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    MVPs and Projects developed within the Incubation Center
                    facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.mvpsAndProjectsStatus)"
                    [style.background]="
                      pickColor(getValue.mvpsAndProjectsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.mvpsAndProjectsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    MVPs and Projects developed within the Incubation Center
                    facility
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.mvpsAndProjectsIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.mvpsAndProjectsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.mvpsAndProjectsUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{ getValue.mvpsAndProjectsUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of MVPs & Prototypes developed :
                            <b>{{ getValue.mvpsAndProjectsUrlNoOfMVP }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.mvpsAndProjectsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.mvpsAndProjectsStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.mvpsAndProjectsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.mvpsAndProjectsStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('mvpsAndProjectsStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('mvpsAndProjectsStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.mvpsAndProjectsStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('mvpsAndProjectsStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Separate meeting / conference / training halls
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.separateMeetingStatus)"
                    [style.background]="
                      pickColor(getValue.separateMeetingStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.separateMeetingStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Separate meeting / conference / training halls</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.separateMeetingIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.separateMeetingIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.separateMeetingUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{ getValue.separateMeetingUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of such facilities created :
                            <b>{{ getValue.separateMeetingUrlNoOfFacility }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.separateMeetingDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.separateMeetingStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.separateMeetingReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.separateMeetingStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('separateMeetingStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('separateMeetingStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.separateMeetingStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('separateMeetingStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header class="d-flex">
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Facility (Incubation Centre) timings
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.facilityTimingsStatus)"
                    [style.background]="
                      pickColor(getValue.facilityTimingsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.facilityTimingsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Facility (Incubation Centre) timings</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.facilityTimingsIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.facilityTimingsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.facilityTimingsUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{ getValue.facilityTimingsUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Facility Timings :
                            <b>{{ getValue.facilityTimings }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.facilityTimingsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.facilityTimingsStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.facilityTimingsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.facilityTimingsStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('facilityTimingsStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('facilityTimingsStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.facilityTimingsStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('facilityTimingsStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Trainings conducted using the Incubation Center facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.trainingsConductedStatus)"
                    [style.background]="
                      pickColor(getValue.trainingsConductedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.trainingsConductedStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Trainings conducted using the Incubation Center facility
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.trainingsConductedIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.trainingsConductedIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs conducted :
                            <b>{{ getValue.trainingsConductedCount }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.trainingsConductedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.trainingsConductedStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.trainingsConductedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.trainingsConductedStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('trainingsConductedStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('trainingsConductedStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.trainingsConductedStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('trainingsConductedStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 009 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header class="d-flex">
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Startups utilizing office space and other facilities
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.startupsUtilizingOffSpaceStatus)
                    "
                    [style.background]="
                      pickColor(getValue.startupsUtilizingOffSpaceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.startupsUtilizingOffSpaceStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Startups utilizing office space and other facilities</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.startupsUtilizingOffSpaceCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.startupsUtilizingOffSpaceCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Total percentatge of Startups utilizing the Office
                            and space and other facilities created :
                            <b>{{
                              getValue.startupsUtilizingOffSpaceTotalPercent
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.startupsUtilizingOffSpaceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.startupsUtilizingOffSpaceStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.startupsUtilizingOffSpaceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.startupsUtilizingOffSpaceStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('startupsUtilizingOffSpaceStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="
                          reviewBtn('startupsUtilizingOffSpaceStatus', 3)
                        "
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.startupsUtilizingOffSpaceStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="
                          rejectBtn('startupsUtilizingOffSpaceStatus', 6)
                        "
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 010 -->
            <mat-expansion-panel [expanded]="step === 9" (opened)="setStep(9)">
              <mat-expansion-panel-header class="d-flex">
                <h6>10.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Policy for Co-creation or Co-incubation facility within the
                    Incubation Center and with external entitites
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.policyForCoCreationStatus)
                    "
                    [style.background]="
                      pickColor(getValue.policyForCoCreationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.policyForCoCreationStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Policy for Co-creation or Co-incubation facility within the
                    Incubation Center and with external entitites
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.policyForCoCreationIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.policyForCoCreationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.policyForCoCreationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.policyForCoCreationStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.policyForCoCreationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[9])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.policyForCoCreationStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('policyForCoCreationStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('policyForCoCreationStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.policyForCoCreationStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('policyForCoCreationStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 011 -->
            <mat-expansion-panel
              [expanded]="step === 10"
              (opened)="setStep(10)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>11.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Provision for other stakeholders who utilize the facility
                    (other than incubatees & Host Institution students) with
                    footfall
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.provisionForStakeholdersStatus)
                    "
                    [style.background]="
                      pickColor(getValue.provisionForStakeholdersStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.provisionForStakeholdersStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Provision for other stakeholders who utilize the facility
                    (other than incubatees & Host Institution students) with
                    footfall
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.provisionForStakeholdersIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.provisionForStakeholdersIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of external Stakeholders :
                            <b>{{
                              getValue.provisionForStakeholdersNoOfVisitor
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.provisionForStakeholdersDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.provisionForStakeholdersStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.provisionForStakeholdersReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[10])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.provisionForStakeholdersStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('provisionForStakeholdersStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('provisionForStakeholdersStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.provisionForStakeholdersStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('provisionForStakeholdersStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 012 -->
            <mat-expansion-panel
              [expanded]="step === 11"
              (opened)="setStep(11)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>12.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Hackathons conducted in the Incubation Centre facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.hackathonsConductedStatus)
                    "
                    [style.background]="
                      pickColor(getValue.hackathonsConductedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.hackathonsConductedStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Hackathons conducted in the Incubation Centre facility
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.hackathonsConductedCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.hackathonsConductedCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs conducted :
                            <b>{{
                              getValue.hackathonsConductedNoOfHackathons
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.hackathonsConductedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.hackathonsConductedStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.hackathonsConductedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[11])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.hackathonsConductedStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('hackathonsConductedStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('hackathonsConductedStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.hackathonsConductedStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('hackathonsConductedStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 013 -->
            <mat-expansion-panel
              [expanded]="step === 12"
              (opened)="setStep(12)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>13.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Revenue generated utilizing this facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.revenueGeneratedUsingSpaceStatus)
                    "
                    [style.background]="
                      pickColor(getValue.revenueGeneratedUsingSpaceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.revenueGeneratedUsingSpaceStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Revenue generated utilizing this facility</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.revenueGeneratedUsingSpaceCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.revenueGeneratedUsingSpaceCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.revenueGeneratedUsingSpaceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.revenueGeneratedUsingSpaceStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.revenueGeneratedUsingSpaceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[12])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.revenueGeneratedUsingSpaceStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('revenueGeneratedUsingSpaceStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="
                          reviewBtn('revenueGeneratedUsingSpaceStatus', 3)
                        "
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.revenueGeneratedUsingSpaceStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="
                          rejectBtn('revenueGeneratedUsingSpaceStatus', 6)
                        "
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
